export default "__VITE_ASSET__043818a3__"